module.exports = __webpack_public_path__ + "static/rainberry-decentralized-1513dfe87bd09752a5277c3c698a72c5.svg";